import React,{useState} from "react";
import {signInWithEmailAndPassword} from "firebase/auth";
import {auth} from "../../firebase/firebase";
import {useNavigate} from "react-router-dom";

export default function AdminLogin(){

  const navigate=useNavigate();

  const[email,setEmail]=useState("");
  const[password,setPassword]=useState("");
  const[error,setError]=useState("");
  const[loading,setLoading]=useState(false);

  const submit=async(e)=>{
    e.preventDefault();
    setError("");

    // ✅ BASIC VALIDATION (prevents crash)
    if(!email || !email.includes("@")){
      setError("Enter a valid email address.");
      return;
    }

    if(!password){
      setError("Enter your password.");
      return;
    }

    setLoading(true);

    try{
      await signInWithEmailAndPassword(
        auth,
        email.trim(),
        password
      );

      // ✅ success
      navigate("/admin/dashboard");

    }catch(err){
      console.error(err);

      // ✅ friendly errors
      if(err.code==="auth/wrong-password"){
        setError("Incorrect password.");
      }else if(err.code==="auth/user-not-found"){
        setError("Account not found.");
      }else if(err.code==="auth/invalid-email"){
        setError("Invalid email format.");
      }else{
        setError("Login failed.");
      }
    }

    setLoading(false);
  };

  return(
    <div className="min-h-screen flex items-center justify-center bg-black text-white">
      <form onSubmit={submit} className="bg-neutral-900 p-8 rounded-xl w-[360px]">

        <h2 className="text-2xl font-bold mb-6 text-center">
          Admin Login
        </h2>

        <input
          value={email}
          onChange={e=>setEmail(e.target.value)}
          placeholder="Email"
          className="w-full mb-4 p-3 rounded bg-neutral-800"
        />

        <input
          type="password"
          value={password}
          onChange={e=>setPassword(e.target.value)}
          placeholder="Password"
          className="w-full mb-4 p-3 rounded bg-neutral-800"
        />

        {error && (
          <p className="text-red-500 text-sm mb-3">
            {error}
          </p>
        )}

        <button
          disabled={loading}
          className="w-full bg-yellow-500 text-black py-3 rounded font-semibold"
        >
          {loading ? "Signing in…" : "Login"}
        </button>

      </form>
    </div>
  );
}
